module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_4.530fdc71.jpg";